var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center cursor-pointer",on:{"click":_vm.onClick}},[_c('span',{staticClass:"text-primary"},[_vm._v("Kasy")]),_c('a-icon',{attrs:{"icon":'Chevron',"iconConfig":{ up: _vm.arrowUp, down: !_vm.arrowUp }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }